import { SALUTATION } from "@/types";
// Salutation "diverse" is not displayed in the UI
export const getSalutationLabel = (t, salutationBffLabel) => {
    switch (salutationBffLabel) {
        case SALUTATION.MR:
            return t("contact.form.salutation_he");
        case SALUTATION.MRS:
            return t("contact.form.salutation_she");
        default:
            return "";
    }
};
